export const DEFAULT_CURRENCY = 'EUR' as const;

export const SUPPORTED_CURRENCIES = ['EUR', 'USD', 'GBP', 'CAD', 'AUD', 'CHF'] as const;
